<template lang="pug">
  div
    section.hero(:class="type")
      .hero-body
        .container.has-text-centered
          h1.is-size-4(v-if="title" v-html="title")
          h2.is-size-5(v-if="subtitle")
            | {{subtitle}}
    section.section
      .container
        slot
    a.gototop.button.is-dark.nopdf(href="#" @click.prevent="Util.smoothScrollTo(0)" title="ページの先頭に戻る")
      b-icon(icon="arrow-up")
</template>

<script>
import Util from '@/utils/util'
export default {
  name: 'BaseContent',
  props: {
    title: {type: String, required: true},
    subtitle: {type: String, required: false, default: ''},
    type: {type: String, required: false, default: 'is-primary'} // is-danger, is-warning等
  },
  data () {
    return {
      Util
    }
  }
}
</script>

<style scoped>
.gototop {
  position: fixed;
  right: 10px;
  bottom: 10px;
  z-index: 30;
}
</style>



// WEBPACK FOOTER //
// src/components/BaseContent.vue